module.exports = __webpack_public_path__ + "static/media/kiara-logo-2020.9673ecc2.png";